import React, { useState, useEffect, useContext } from 'react';
import './editClient.style.scss';
// import clientPlaceHolder from '../../../../../assets/svg/company-logo-placeholder.svg';
import { AccountContext } from '../../../Contexts/main.context';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from "react-router-dom";

const EditClient = ({ clientData = {} }) => {

     const navigate = useNavigate();

     const context = useContext(AccountContext);

     const { actionButtons,
          updateActionButtons,
          updateActiveOutlet,
          updateActiveClient,
          clientAccounts,
          updateClientAccounts,
          userAccounts,
          googleCategories,
          updateMasked,
          originalID, } = context || {};

     const [showCatModal, setShowCatModal] = useState(false);
     const [whatField, setWhatField] = useState('');
     const [LGOUser, setLGOUser] = useState([]);
     const [editCustomer, setEditCustomer] = useState(null);


     useEffect(() => {
          const confirmUser = () => {
               const userToken = localStorage.getItem("LGOUser");
               if (userToken) {
                    try {
                         const decoded = jwtDecode(userToken);
                         const currentTime = Math.floor(Date.now() / 1000);
                         if (decoded.exp && decoded.exp < currentTime) {
                              setLGOUser(decoded);
                              console.log(LGOUser);
                         } else {
                              // localStorage.removeItem("LGOUser");
                              // navigate("/login");
                         }
                    } catch (error) {
                         // localStorage.removeItem("LGOUser");
                         // navigate("/login");
                    }
               } else {
                    navigate("/login");
               }
          }
          confirmUser();
          updateMasked(true);
          // eslint-disable-next-line 
     }, []);

     const [client, setClient] = useState({
          ID: clientData.ID || '',
          companyName: clientData.companyName || '',
          theLocation: clientData.theLocation || '',
          phone: clientData.phone || '',
          contactPerson: clientData.contactPerson || '',
          email: clientData.email || '',
          address: clientData.address || '',
          city: clientData.city || '',
          province: clientData.province || '',
          postal: clientData.postal || '',
          description: clientData.description || '',
          accountmanager: clientData.accountmanager || '',
          accountManagerID: clientData.accountManagerID || '',
          status: clientData.status || '',
          logoLink: clientData.logoLink || '',
          googleID: clientData.googleID || '',
          gmbLink: clientData.gmbLink || '',
          clientUser: clientData.clientUser || '',
          clientUserPassword: clientData.clientUserPassword || '',
          locationID: clientData.locationID || 0,
          storeHours: clientData.storeHours || {
               Sunday: { opening: '08:00', closing: '19:00' },
               Monday: { opening: '', closing: '05:15 PM' },
               Tuesday: { opening: '', closing: '' },
               Wednesday: { opening: '', closing: '' },
               Thursdday: { opening: '', closing: '' },
               Friday: { opening: '', closing: '' },
               Saturday: { opening: '', closing: '' },
          },
          extraBusiness: clientData.extraBusiness || ["", "", "", "", ""],
          extraProduct: clientData.extraProduct || ["", "", "", "", ""],
          socialMedia: clientData.socialMedia || {
               Facebook: { link: "" },
               Instagram: { link: "" },
               LinkedIn: { link: "" },
               Pinterest: { link: "" },
               TikTok: { link: "" },
               X: { link: "" },
               YouTube: { link: "" }
          },
          website: clientData.website || '',
          primaryCat: clientData.primaryCat || '',
          citationEmail: clientData.citationEmail || '',
          companyOwner: clientData.companyOwner || '',
          citationPass: clientData.citationPass || '',
     });

     // const logoInputRef = useRef(null);
     const [catQuery, setCatQuery] = useState('');
     // eslint-disable-next-line
     const [activeQueryIndex, setActiveQueryIndex] = useState(null);

     const updateClientContext = (newLogoLink, ID) => {
          const updatedList = clientAccounts.map(account => {
               if (account.ID === ID) {
                    return { ...account, logoLink: newLogoLink }; // ✅ only logoLink is updated
               }
               return account;
          });
          updateClientAccounts(updatedList);
          const updatedClient = updatedList.find(account => account.ID === ID);
          updateActiveClient(updatedClient); // ✅ full updated client
     };


     const handleChange = (e) => {
          const { name, value } = e.target;
          setClient(prev => ({ ...prev, [name]: value }));
     };

     const handleLogoUpload = async (e) => {
          const file = e.target.files[0];
          if (!file) return;

          const formDataImage = new FormData();
          formDataImage.append("image", file);
          formDataImage.append("ID", client.ID);

          try {
               const response = await fetch("https://www.lgfantasy.ca/Citations/PHP/companyLogoUpload.php", {
                    method: "POST",
                    body: formDataImage,
               });

               const data = await response.json();
               if (data.status === "success") {
                    setClient(prev => ({ ...prev, logoLink: data.imagePath }));
                    updateClientContext(data.imagePath, client.ID);

               }
          } catch (error) {
               console.error("Error uploading logo:", error);
          }
     };

     const setModalButton = (inval) => {
          setWhatField(inval);
          setShowCatModal(true);
     }

     const handleSubmit = async (e) => {
          e.preventDefault();
          const updatedClient = { ...client, script: "updateClient" };
          try {
               const response = await fetch("https://www.lgfantasy.ca/Citations/PHP/data.php", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(updatedClient),
               });

               const data = await response.json();
               if (data.status === "success") {
                    const updatedList = clientAccounts.map(account =>
                         account.ID === client.ID ? client : account
                    );
                    updateMasked(false);
                    updateClientAccounts(updatedList);
                    updateActiveClient(client);
                    cancelSave();

               } else {
                    alert("Error saving client.");
               }
          } catch (error) {
               alert("An error occurred Saving Data");
          }
     };

     // const editCitations = () => {
     //      updateClientID(client.ID);
     //      updateBoxOpen("editCitations");
     // };

     const filteredCats = googleCategories.filter(cat =>
          cat.category?.toLowerCase().includes(catQuery.toLowerCase())
     );


     const cancelSave = () => {
          actionButtons?.forEach(element => {
               element.selected = false;
          });
          actionButtons[1].selected = true;
          updateMasked(false);
          updateActiveOutlet('ViewCustomer');
     }

     const letsDeleteThis = async () => {
          if (window.confirm("Are you Sure you want to Delete this Record, This will delete all Citations Data from the System with This Client'")) {
               const updatedClient = { ID: client.ID, script: "deleteClient" };
               try {
                    const response = await fetch("https://www.lgfantasy.ca/Citations/PHP/special.php", {
                         method: "POST",
                         headers: { "Content-Type": "application/json" },
                         body: JSON.stringify(updatedClient),
                    });
                    const data = await response.json();
                    if (data) {
                         const masterRecord = data.find(needle => needle.ID === originalID);
                         updateActiveClient(masterRecord);
                         const locations = data.filter(needle => needle.locationID === originalID);
                         const locationCount = locations.length;
                         updateMasked(false);
                         updateClientAccounts(data);
                         actionButtons.forEach((element) => {
                              element.selected = false;
                         });
                         const changeRecord = actionButtons.find(needle => needle.action === 'ViewLocation');
                         changeRecord.label = `Locations (${locationCount + 1})`;
                         changeRecord.selected = true;

                         updateActionButtons(actionButtons);
                         updateActiveOutlet('ViewLocation');
                    } else {
                         alert("Error Deleting client.");
                    }
               } catch (error) {
                    alert("An error occurred Deleting Data??");
               }
          }
     }

     const processEditCreate = () => {
          if (client.locationID === '0') {
               if (client.clientUser.length === 0) {
                    setEditCustomer('Create');
                    console.log('Create Account');
               } else {
                    setEditCustomer('Edit');
                    console.log('Edit Client');
               }
          } else {
               console.log('cannot create account or edit account that is not Original Record');
          }
     }

     const handleCreateAccount = (inval) => {
          if (inval === 'Cancel') {
               setEditCustomer(null);
          } else {
               const updatedClient = {
                    script: "creatAccount",
                    user: client.ID,
                    username: client.clientUser,
                    pass: client.clientUserPassword,
               };

               try {
                    fetch("https://www.lgfantasy.ca/Citations/PHP/special.php", {
                         method: "POST",
                         headers: { "Content-Type": "application/json" },
                         body: JSON.stringify(updatedClient),
                    });
                    setEditCustomer(null);
               } catch (error) {
                    alert("An error occurred sending account creation request.");
                    console.error(error);
               }
          }
     };


     const handleSaveEdit = (inval) => {
          console.log(inval);
          if (inval === 'Cancel') {
               setEditCustomer(null);
          } else {
               const updatedClient = {
                    script: "updateAccount",
                    user: client.ID,
                    username: client.clientUser,
                    pass: client.clientUserPassword,
               };

               try {
                    fetch("https://www.lgfantasy.ca/Citations/PHP/special.php", {
                         method: "POST",
                         headers: { "Content-Type": "application/json" },
                         body: JSON.stringify(updatedClient),
                    });
                    setEditCustomer(null);
               } catch (error) {
                    alert("An error occurred sending account creation request.");
                    console.error(error);
               }
          }
     }

     return (
          <>
               <div className="container bg-light rounded-2 ">
                    <div className="position-sticky top-0 py-3 alert-dark row">
                         <div className="d-flex px-3 gap-2 align-items-center">
                              <div>
                                   <button className='btn btn-danger text-white' type="submit" onClick={cancelSave}>Cancel</button>
                              </div>
                              {client.locationID !== '0' &&
                                   <div className='fw-bold text-danger'>To Delete Account, Scroll to Bottom</div>
                              }
                              <div className="ms-auto d-flex gap-2">
                                   <button className='btn btn-success text-white' type="submit" onClick={handleSubmit}>Save Client</button>
                              </div>
                         </div>
                    </div>

                    <div className=''>
                         <div className="text-center mt-4">
                              <label htmlFor="logoInput" style={{ cursor: "pointer", display: "inline-block", width: "100%" }}>
                                   {client.logoLink ? (
                                        <img
                                             src={`https://www.lgfantasy.ca/Citations/PHP/${client.logoLink}`}
                                             alt="Company Logo"
                                             style={{
                                                  width: '100%',
                                                  height: 'auto',
                                                  maxHeight: "175px",
                                                  objectFit: 'contain',
                                                  backgroundColor: '#fff',
                                                  border: '1px solid #ccc',
                                                  borderRadius: '4px',
                                                  padding: '4px'
                                             }}
                                        />
                                   ) : (
                                        <svg width="100%" height="120" xmlns="http://www.w3.org/2000/svg">
                                             <text x="50%" y="50%" dominantBaseline="middle" textAnchor="middle" fill="#888" fontSize="12">
                                                  Company Logo - Press to Upload
                                             </text>
                                        </svg>
                                   )}
                              </label>

                              <input
                                   type="file"
                                   id="logoInput"
                                   accept="image/*"
                                   style={{ display: "none" }}
                                   onChange={handleLogoUpload}
                              />
                         </div>

                         <div className="row p-3">
                              <div className="oneLine">
                                   <div className="col-2">
                                        <label>ID</label>
                                        <input className='form-control' type="text" name="ID" value={client.ID} readOnly style={{ backgroundColor: "#ccc" }} />
                                   </div>
                                   <div className="col-12">
                                        <label>Company Name</label>
                                        <input className='form-control' type="text" name="companyName" value={client.companyName} onChange={handleChange} />
                                   </div>
                                   <div className="col-12">
                                        <label>Location Name</label>
                                        <input className='form-control' type="text" name="theLocation" value={client.theLocation} onChange={handleChange} />
                                   </div>
                                   <div className="col-8">
                                        <label>Phone</label>
                                        <input className='form-control' type="text" name="phone" value={client.phone} onChange={handleChange} />
                                   </div>
                                   <div className="flex-grow-1">
                                        <label>Google ID</label>
                                        <input className='form-control' type="text" name="gmbLink" value={client.gmbLink} onChange={handleChange} />
                                   </div>
                              </div>
                              <div className="oneLine mt-1">
                                   <div className="col-20">
                                        <label>Address</label>
                                        <input className='form-control' type="text" name="address" value={client.address} onChange={handleChange} />
                                   </div>
                                   <div className="col-10">
                                        <label>City</label>
                                        <input className='form-control' type="text" name="city" value={client.city} onChange={handleChange} />
                                   </div>
                                   <div className="col-8">
                                        <label>Province (2 Letters)</label>
                                        <input className='form-control' type="text" name="province" value={client.province} onChange={handleChange} />
                                   </div>
                                   <div className=" col-8 flex-grow-1">
                                        <label>Postal</label>
                                        <input className='form-control' type="text" name="postal" value={client.postal} onChange={handleChange} />
                                   </div>

                              </div>
                              <div className="oneLine mt-1">
                                   <div className="col-16">
                                        <label>Contact Person</label>
                                        <input className='form-control' type="text" name="contactPerson" value={client.contactPerson} onChange={handleChange} />
                                   </div>
                                   <div className="col-15">
                                        <label>Account Manager</label>
                                        <select className="form-select"
                                             name="accountmanager"
                                             value={client.accountmanager}
                                             onChange={handleChange}>
                                             <option value="-">-</option>
                                             {userAccounts.map((user, index) => (
                                                  <option key={index} value={user.displayName}>
                                                       {user.displayName}
                                                  </option>
                                             ))}
                                        </select>

                                   </div>
                                   <div className="col-15 flex-grow-1">
                                        <label>Status</label>
                                        <select className="form-select"
                                             name="status"
                                             value={client.status}
                                             onChange={handleChange}>
                                             <option value="Active">Active</option>
                                             <option value="Not Active">Not Active</option>
                                        </select>
                                   </div>
                              </div>
                              <div className="oneLine mt-1">
                                   <div className="col-112">
                                        <label>Business Category</label>
                                        <input
                                             type="text"
                                             className='form-control'
                                             name="primaryCat"
                                             value={client.primaryCat}
                                             onChange={(e) => {
                                                  handleChange(e);
                                                  setCatQuery(e.target.value);
                                             }}
                                             autoComplete="off"
                                        />
                                   </div>
                                   <div className="col-4">
                                        <label>Categories</label>
                                        <div className="btn btn-navy col-46 offset-1" onClick={() => setModalButton('primaryCat')}>?</div>
                                   </div>
                                   <div className="col-15">
                                        <label>Website</label>
                                        <input className='form-control' type="text" name="website" value={client.website} onChange={handleChange} />
                                   </div>
                                   <div className="col-15 flex-grow-1">
                                        <label>Email</label>
                                        <input className='form-control' type="text" name="email" value={client.email} onChange={handleChange} />
                                   </div>

                              </div>
                              <div className="w-100 mt-1 alert-navy p-3">
                                   {client.locationID === '0' && editCustomer === null && (
                                        // ✅ Main Account Info Box (Initial View - Location ID 0)
                                        <div className="w-100 d-flex gap-2 align-items-center">
                                             <div className="w-25 p-3">
                                                  <div className="">
                                                       <div className="d-flex gap-2">
                                                            <div className="fw-bold text-end col-24">Username:</div>
                                                            <div>{client.clientUser}</div>
                                                       </div>
                                                       <div className="d-flex gap-2">
                                                            <div className="fw-bold text-end col-24">Password:</div>
                                                            <div>{client.clientUserPassword}</div>
                                                       </div>
                                                       <div className="d-flex gap-2">
                                                            <div className="fw-bold text-end col-24">Account Master:</div>
                                                            <div>{client.ID}</div>
                                                       </div>
                                                  </div>
                                             </div>
                                             <div className="col-50 px-5 text-center">
                                                  <div>This information is Created and Maintained for the Client Facing Login.</div>
                                                  <div className="fw-bold">If An Account has been Created you can only Edit the Data</div>
                                             </div>
                                             <div className="flex-grow-1 text-center">
                                                  <div className="btn btn-navy w-50" onClick={() => processEditCreate()}>
                                                       {client.clientUser.length > 0 ? 'Edit Account' : 'Create Account'}
                                                  </div>
                                             </div>
                                        </div>
                                   )}

                                   {client.locationID !== '0' && editCustomer === null && (
                                        // 🚫 Sub-location Warning Box
                                        <div className="w-100 d-flex gap-2 align-items-center">
                                             <div className="w-25 p-3"></div>
                                             <div className="w-50 px-5 text-center fw-bold">

                                                  If you want to change the <strong>Client Facing Username/Password</strong>, please choose <strong>Locations</strong>, then → <strong>Original Location</strong>.


                                             </div>
                                             <div className="flex-grow-1 text-center"></div>
                                        </div>
                                   )}

                                   {client.locationID === '0' && editCustomer === 'Edit' && (
                                        // ✏️ Edit Account Box
                                        <div className="w-100 d-flex gap-2 align-items-center">
                                             <div className="col-20 p-3">
                                                  {/* Add inputs for editing username/password/etc. */}
                                                  <div className="d-flex gap-2 mb-2">
                                                       <div className="fw-bold text-end col-24">Username:</div>
                                                       <input
                                                            className="form-control"
                                                            value={client.clientUser}
                                                            onChange={(e) =>
                                                                 setClient((prev) => ({ ...prev, clientUser: e.target.value }))
                                                            }
                                                       />
                                                  </div>
                                                  <div className="d-flex gap-2">
                                                       <div className="fw-bold text-end col-24">Password:</div>
                                                       <input
                                                            className="form-control"
                                                            value={client.clientUserPassword}
                                                            onChange={(e) =>
                                                                 setClient((prev) => ({ ...prev, clientUserPassword: e.target.value }))
                                                            }
                                                       />
                                                  </div>
                                             </div>
                                             <div className="col-15 px-5 text-center">
                                                  <div className="fw-bold">You are now editing this Client Login</div>
                                             </div>
                                             <div className="flex-grow-1 text-center d-flex justify-content-end gap-2">
                                                  <div className="btn btn-success text-light" onClick={() => handleSaveEdit('Save')}>
                                                       Save Changes
                                                  </div>
                                                  <div className="btn btn-danger text-light" onClick={() => handleSaveEdit('Cancel')}>
                                                       Cancel
                                                  </div>
                                             </div>
                                        </div>
                                   )}

                                   {client.locationID === '0' && editCustomer === 'Create' && (
                                        // ➕ Create Account Box
                                        <div className="w-100 d-flex gap-2 align-items-center">
                                             <div className="col-20 p-3">
                                                  {/* Inputs for creating new account */}
                                                  <div className="d-flex gap-2 mb-2">
                                                       <div className="fw-bold text-end col-24">New Username:</div>
                                                       <input
                                                            className="form-control"
                                                            value={client.clientUser}
                                                            onChange={(e) =>
                                                                 setClient((prev) => ({ ...prev, clientUser: e.target.value }))
                                                            }
                                                       />
                                                  </div>
                                                  <div className="d-flex gap-2">
                                                       <div className="fw-bold text-end col-24">New Password:</div>
                                                       <input
                                                            className="form-control"
                                                            value={client.clientUserPassword}
                                                            onChange={(e) =>
                                                                 setClient((prev) => ({ ...prev, clientUserPassword: e.target.value }))
                                                            }
                                                       />
                                                  </div>
                                             </div>
                                             <div className="col-15 px-5 text-center">
                                                  <div className="fw-bold">You are now creating a new login for this Client</div>
                                             </div>
                                             <div className="flex-grow-1 d-flex gap-2 justify-content-end">
                                                  <div className="btn btn-primary" onClick={() => handleCreateAccount('Create')}>
                                                       Create Account
                                                  </div>
                                                  <div className="btn btn-danger" onClick={() => handleCreateAccount('Cancel')}>
                                                       Cancel
                                                  </div>
                                             </div>
                                        </div>
                                   )}
                              </div>


                              <div className="oneLine mt-2">
                                   <div className="flex-grow-1">
                                        <label>Description</label>
                                        <textarea className='form-control' name="description" rows="6" value={client.description} onChange={handleChange} />
                                   </div>
                              </div>
                              <div className="col-48 p-2 mt-3">
                                   <label className="fw-bold">Social Media Links</label>
                                   <div className="d-flex flex-wrap gap-1 justify-content-center">
                                        {Object.entries(client.socialMedia).map(([platform, data], index) => (
                                             <div key={index} className="mt-2 col-22">
                                                  <label>{platform}</label>
                                                  <input
                                                       type="text"
                                                       className="form-control"
                                                       value={data.link}
                                                       onChange={(e) => {
                                                            const updated = {
                                                                 ...client.socialMedia,
                                                                 [platform]: { ...client.socialMedia[platform], link: e.target.value }
                                                            };
                                                            setClient(prev => ({ ...prev, socialMedia: updated }));
                                                       }}
                                                  />
                                             </div>
                                        ))}
                                   </div>
                              </div>


                              <div className="oneLine mt-4">
                                   <div className="col-15 alert-dark p-3">
                                        <div className="d-flex align-items-center" style={{ height: "35px" }}>
                                             <label className='fw-bold'>Store Hours</label>
                                             <div className="d-flex ms-auto">
                                                  <button
                                                       type="button"
                                                       className="btn btn-sm btn-success text-white"
                                                       onClick={() => {
                                                            const newHours = { ...client.storeHours };
                                                            Object.keys(newHours).forEach(day => {
                                                                 if (day !== "Sunday") {
                                                                      newHours[day] = { opening: "09:00", closing: "17:00" };
                                                                 }
                                                            });
                                                            setClient(prev => ({ ...prev, storeHours: newHours }));
                                                       }}
                                                  >
                                                       Fill in Default
                                                  </button>
                                             </div>
                                        </div>
                                        {Object.entries(client.storeHours).map(([day, times], idx) => (
                                             <div key={idx} className="mt-2">
                                                  <strong>{day}</strong>
                                                  <div className="d-flex gap-2">
                                                       <input
                                                            type="time"
                                                            className="form-control"
                                                            placeholder="Open"
                                                            value={times.opening}
                                                            onChange={(e) => {
                                                                 const updated = {
                                                                      ...client.storeHours,
                                                                      [day]: { ...client.storeHours[day], opening: e.target.value },
                                                                 };
                                                                 setClient(prev => ({ ...prev, storeHours: updated }));

                                                            }}
                                                       />
                                                       <input
                                                            type="time"
                                                            className="form-control"
                                                            placeholder="Close"
                                                            value={times.closing}
                                                            onChange={(e) => {
                                                                 const updated = {
                                                                      ...client.storeHours,
                                                                      [day]: { ...client.storeHours[day], closing: e.target.value },
                                                                 };
                                                                 setClient(prev => ({ ...prev, storeHours: updated }));
                                                            }}
                                                       />
                                                  </div>
                                             </div>
                                        ))}
                                   </div>
                                   <div className="col-15 alert-dark p-3">
                                        <div className="d-flex align-items-center mb-4" style={{ height: "35px" }}>
                                             <label className='fw-bold'>Extra Business Categories</label>
                                        </div>
                                        {client.extraBusiness.map((item, index) => {
                                             return (
                                                  <div key={index} className="position-relative mb-3 d-flex gap-2">
                                                       <div className="col-40">
                                                            <input
                                                                 type="text"
                                                                 className="form-control"
                                                                 value={item}
                                                                 onChange={(e) => {
                                                                      const updated = [...client.extraBusiness];
                                                                      updated[index] = e.target.value;
                                                                      setClient(prev => ({ ...prev, extraBusiness: updated }));
                                                                      setActiveQueryIndex(index);
                                                                 }}
                                                                 autoComplete="off"
                                                            />
                                                       </div>
                                                       <div className="flex-grow-1">
                                                            <div className="btn btn-navy col-48" onClick={() => setModalButton(`extraBusiness_${index}`)}>?</div>
                                                       </div>
                                                  </div>
                                             );
                                        })}


                                   </div>

                                   <div className="col-15 flex-grow-1 alert-dark p-3">
                                        <div className="d-flex align-items-center mb-4" style={{ height: "35px" }}>
                                             <label className='fw-bold'>Extra Product Categories</label>
                                        </div>
                                        {client.extraProduct.map((item, index) => (
                                             <div key={index} className="mb-3">
                                                  <input
                                                       type="text"
                                                       className="form-control"
                                                       value={item}
                                                       onChange={(e) => {
                                                            const updated = [...client.extraProduct];
                                                            updated[index] = e.target.value;
                                                            setClient(prev => ({ ...prev, extraProduct: updated }));
                                                       }}
                                                       autoComplete="off"
                                                  />
                                             </div>
                                        ))}
                                   </div>

                              </div>
                              {client.locationID !== '0' &&
                                   <div className="oneLine p-3 justify-content-end">
                                        <div>
                                             <div className="btn btn-danger px-5" onClick={() => letsDeleteThis()}>Delete This Record</div>
                                        </div>
                                   </div>
                              }
                         </div>
                    </div>
               </div>
               {showCatModal && (
                    <div className="modal d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                         <div className="modal-dialog modal-lg" role="document">
                              <div className="modal-content">
                                   <div className="modal-header">
                                        <h5 className="modal-title text-primary">Select a Business Category</h5>
                                        <button type="button"
                                             className="btn-close" onClick={() => setShowCatModal(false)}></button>
                                   </div>
                                   <div className="modal-body">
                                        <input
                                             type="text"
                                             className="form-control mb-3"
                                             placeholder="Search Categories"
                                             value={catQuery}
                                             onChange={(e) => setCatQuery(e.target.value)}
                                             autoFocus
                                        />
                                        <div className="list-group" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                             {filteredCats.slice(0, 25).map((cat, index) => (
                                                  <button
                                                       key={index}
                                                       type="button"
                                                       className="list-group-item list-group-item-action"
                                                       onClick={() => {
                                                            if (whatField.startsWith('extraBusiness_')) {
                                                                 const index = parseInt(whatField.split('_')[1], 10);
                                                                 const updated = [...client.extraBusiness];
                                                                 updated[index] = cat.category;
                                                                 setClient(prev => ({ ...prev, extraBusiness: updated }));
                                                            } else {
                                                                 setClient(prev => ({
                                                                      ...prev,
                                                                      [whatField]: cat.category
                                                                 }));
                                                            }
                                                            setShowCatModal(false);
                                                            setCatQuery('');
                                                       }}


                                                  >
                                                       {cat.category}
                                                  </button>
                                             ))}
                                             {filteredCats.length === 0 && (
                                                  <div className="text-muted">No categories found.</div>
                                             )}
                                        </div>
                                   </div>
                                   <div className="modal-footer">
                                        <button className="btn btn-secondary" onClick={() => setShowCatModal(false)}>
                                             Close
                                        </button>
                                   </div>
                              </div>
                         </div>
                    </div>
               )}
          </>
     );
};

export default EditClient;
